// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"76d685ca","336":"5f1a86be","455":"d7c3dbf1","644":"a9876f66","831":"a903da6b"}[chunkId] + ".chunk.js";
};